<template>
  <div v-if="profile.id !== 0">
    <ProfileDesktop
      :data="profile"
    />
  </div>
</template>

<script>
import profilePage from '@/mixins/pages/profile';

export default {
  components: {
    ProfileDesktop: () => import(/* webpackChunkName: "page--Profile--Desktop" */ '@/components/profile/ProfileDesktop'),
  },

  mixins: [
    profilePage, //
  ],

  mounted() {
    if (this.profile.uuid !== this.$route.params.profile) {
      this.profile.id = 0;
    }
  },
};
</script>
